import { useTranslation } from 'react-i18next';

export function useIsRTL() {
	const { i18n } = useTranslation();
	const rtlLanguages = ['ar', 'fa'];

	// Handle cases like 'fa-IR' by checking the base language code
	return (
		rtlLanguages.includes(i18n.language) || rtlLanguages.includes(i18n.language.split('-')[0] ?? '')
	);
}
